module.exports = __webpack_public_path__ + "img/0828-chevron-left.2f28c5c2.svg";